var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { IconLoading } from '../icons/IconLoading';
// Reusable Button Component
var Button = function (_a) {
    var children = _a.children, onClick = _a.onClick, icon = _a.icon, _b = _a.className, className = _b === void 0 ? '' : _b, _c = _a.iconClass, iconClass = _c === void 0 ? '' : _c, _d = _a.type, type = _d === void 0 ? 'button' : _d, // Default type is 'button'
    _e = _a.isLoading, // Default type is 'button'
    isLoading = _e === void 0 ? false : _e, props = __rest(_a, ["children", "onClick", "icon", "className", "iconClass", "type", "isLoading"]);
    return (_jsx("button", __assign({ type: type, onClick: onClick, className: className
            ? className
            : 'disabled:vas-cursor-not-allowed disabled:vas-bg-gray-400 vas-bg-primary' }, props, { children: _jsxs("div", { className: 'vas-flex vas-justify-center vas-items-center vas-gap-2', children: [isLoading && _jsx(IconLoading, {}), icon && _jsx("span", { className: iconClass, children: icon }), children] }) })));
};
export default Button;
